import React from "react";
import { Box, Typography } from "@mui/material";
import StyledFavItems from "./StyledFavItems";
import FavItems from "../../pages/Favourites/FavItems";
import { FAVOURITE_ITEM } from "../../constants/lang";
import { Link } from "react-router-dom";
import { ROUTE_PATH } from "../../constants/route";

const FavouriteItem = ({ favData, favDataLoading }) => {
  return (
    <StyledFavItems>
      <Box className="right-container">
        <Box className="content-box">
          <Typography className="fav-title">{FAVOURITE_ITEM.title}</Typography>
          <FavItems
            showPagination={false}
            sxHeight={"auto"}
            loaderHeight="72%"
            loading={favDataLoading}
            favData={favData}
          />

          {favData?.length > 0 && <Box className="button-box">
            <Link
              className="product-button"
              to={ROUTE_PATH.FAVOURITES}
              aria-label="view products"
            >
              {FAVOURITE_ITEM.button}
            </Link>
          </Box>}
        </Box>
      </Box>
    </StyledFavItems>
  );
};

export default FavouriteItem;
